var map = {
	"./af": 7925,
	"./af.d": 97652,
	"./af.d.ts": 97652,
	"./af.js": 7925,
	"./ak": 98578,
	"./ak.d": 21027,
	"./ak.d.ts": 21027,
	"./ak.js": 98578,
	"./am": 4436,
	"./am.d": 51409,
	"./am.d.ts": 51409,
	"./am.js": 4436,
	"./an": 18909,
	"./an.d": 62460,
	"./an.d.ts": 62460,
	"./an.js": 18909,
	"./ar": 48617,
	"./ar.d": 47352,
	"./ar.d.ts": 47352,
	"./ar.js": 48617,
	"./ars": 91916,
	"./ars.d": 69275,
	"./ars.d.ts": 69275,
	"./ars.js": 91916,
	"./as": 94458,
	"./as.d": 15563,
	"./as.d.ts": 15563,
	"./as.js": 94458,
	"./asa": 6743,
	"./asa.d": 80936,
	"./asa.d.ts": 80936,
	"./asa.js": 6743,
	"./ast": 6332,
	"./ast.d": 93607,
	"./ast.d.ts": 93607,
	"./ast.js": 6332,
	"./az": 97201,
	"./az.d": 7424,
	"./az.d.ts": 7424,
	"./az.js": 97201,
	"./bal": 96379,
	"./bal.d": 57840,
	"./bal.d.ts": 57840,
	"./bal.js": 96379,
	"./be": 88987,
	"./be.d": 18098,
	"./be.d.ts": 18098,
	"./be.js": 88987,
	"./bem": 15520,
	"./bem.d": 68599,
	"./bem.d.ts": 68599,
	"./bem.js": 15520,
	"./bez": 34565,
	"./bez.d": 146,
	"./bez.d.ts": 146,
	"./bez.js": 34565,
	"./bg": 53405,
	"./bg.d": 13016,
	"./bg.d.ts": 13016,
	"./bg.js": 53405,
	"./bho": 58787,
	"./bho.d": 69748,
	"./bho.d.ts": 69748,
	"./bho.js": 58787,
	"./bm": 20531,
	"./bm.d": 10458,
	"./bm.d.ts": 10458,
	"./bm.js": 20531,
	"./bn": 84534,
	"./bn.d": 51251,
	"./bn.d.ts": 51251,
	"./bn.js": 84534,
	"./bo": 19125,
	"./bo.d": 73088,
	"./bo.d.ts": 73088,
	"./bo.js": 19125,
	"./br": 63810,
	"./br.d": 82935,
	"./br.d.ts": 82935,
	"./br.js": 63810,
	"./brx": 41184,
	"./brx.d": 72295,
	"./brx.d.ts": 72295,
	"./brx.js": 41184,
	"./bs": 65873,
	"./bs.d": 63316,
	"./bs.d.ts": 63316,
	"./bs.js": 65873,
	"./ca": 11470,
	"./ca.d": 82611,
	"./ca.d.ts": 82611,
	"./ca.js": 11470,
	"./ce": 10370,
	"./ce.d": 64943,
	"./ce.d.ts": 64943,
	"./ce.js": 10370,
	"./ceb": 73570,
	"./ceb.d": 26169,
	"./ceb.d.ts": 26169,
	"./ceb.js": 73570,
	"./cgg": 41779,
	"./cgg.d": 40668,
	"./cgg.d.ts": 40668,
	"./cgg.js": 41779,
	"./chr": 1159,
	"./chr.d": 91368,
	"./chr.d.ts": 91368,
	"./chr.js": 1159,
	"./ckb": 82396,
	"./ckb.d": 10327,
	"./ckb.d.ts": 10327,
	"./ckb.js": 82396,
	"./cs": 36532,
	"./cs.d": 96373,
	"./cs.d.ts": 96373,
	"./cs.js": 36532,
	"./cy": 80022,
	"./cy.d": 41371,
	"./cy.d.ts": 41371,
	"./cy.js": 80022,
	"./da": 49709,
	"./da.d": 37756,
	"./da.d.ts": 37756,
	"./da.js": 49709,
	"./de": 48305,
	"./de.d": 71536,
	"./de.d.ts": 71536,
	"./de.js": 48305,
	"./doi": 75216,
	"./doi.d": 5739,
	"./doi.d.ts": 5739,
	"./doi.js": 75216,
	"./dsb": 55965,
	"./dsb.d": 78790,
	"./dsb.d.ts": 78790,
	"./dsb.js": 55965,
	"./dv": 39272,
	"./dv.d": 16421,
	"./dv.d.ts": 16421,
	"./dv.js": 39272,
	"./dz": 78508,
	"./dz.d": 8601,
	"./dz.d.ts": 8601,
	"./dz.js": 78508,
	"./ee": 69672,
	"./ee.d": 4466,
	"./ee.d.ts": 4466,
	"./ee.js": 69672,
	"./el": 30231,
	"./el.d": 70098,
	"./el.d.ts": 70098,
	"./el.js": 30231,
	"./en": 26105,
	"./en.d": 19064,
	"./en.d.ts": 19064,
	"./en.js": 26105,
	"./eo": 13322,
	"./eo.d": 90699,
	"./eo.d.ts": 90699,
	"./eo.js": 13322,
	"./es": 70446,
	"./es.d": 26911,
	"./es.d.ts": 26911,
	"./es.js": 70446,
	"./et": 50831,
	"./et.d": 18890,
	"./et.d.ts": 18890,
	"./et.js": 50831,
	"./eu": 4024,
	"./eu.d": 90837,
	"./eu.d.ts": 90837,
	"./eu.js": 4024,
	"./fa": 27811,
	"./fa.d": 36386,
	"./fa.d.ts": 36386,
	"./fa.js": 27811,
	"./ff": 47418,
	"./ff.d": 89591,
	"./ff.d.ts": 89591,
	"./ff.js": 47418,
	"./fi": 61835,
	"./fi.d": 50794,
	"./fi.d.ts": 50794,
	"./fi.js": 61835,
	"./fil": 49255,
	"./fil.d": 42476,
	"./fil.d.ts": 42476,
	"./fil.js": 49255,
	"./fo": 86289,
	"./fo.d": 8924,
	"./fo.d.ts": 8924,
	"./fo.js": 86289,
	"./fr": 88054,
	"./fr.d": 76427,
	"./fr.d.ts": 76427,
	"./fr.js": 88054,
	"./fur": 19953,
	"./fur.d": 71198,
	"./fur.d.ts": 71198,
	"./fur.js": 19953,
	"./fy": 92507,
	"./fy.d": 12282,
	"./fy.d.ts": 12282,
	"./fy.js": 92507,
	"./ga": 92402,
	"./ga.d": 20903,
	"./ga.d.ts": 20903,
	"./ga.js": 92402,
	"./gd": 86813,
	"./gd.d": 22296,
	"./gd.d.ts": 22296,
	"./gd.js": 86813,
	"./gl": 27413,
	"./gl.d": 91424,
	"./gl.d.ts": 91424,
	"./gl.js": 27413,
	"./gsw": 82115,
	"./gsw.d": 10596,
	"./gsw.d.ts": 10596,
	"./gsw.js": 82115,
	"./gu": 7374,
	"./gu.d": 30907,
	"./gu.d.ts": 30907,
	"./gu.js": 7374,
	"./guw": 59369,
	"./guw.d": 30958,
	"./guw.d.ts": 30958,
	"./guw.js": 59369,
	"./gv": 8587,
	"./gv.d": 2050,
	"./gv.d.ts": 2050,
	"./gv.js": 8587,
	"./ha": 81777,
	"./ha.d": 4176,
	"./ha.d.ts": 4176,
	"./ha.js": 81777,
	"./haw": 22200,
	"./haw.d": 1791,
	"./haw.d.ts": 1791,
	"./haw.js": 22200,
	"./he": 42989,
	"./he.d": 32700,
	"./he.d.ts": 32700,
	"./he.js": 42989,
	"./hi": 58313,
	"./hi.d": 66344,
	"./hi.d.ts": 66344,
	"./hi.js": 58313,
	"./hnj": 65828,
	"./hnj.d": 19299,
	"./hnj.d.ts": 19299,
	"./hnj.js": 65828,
	"./hr": 16200,
	"./hr.d": 17765,
	"./hr.d.ts": 17765,
	"./hr.js": 16200,
	"./hsb": 39321,
	"./hsb.d": 51010,
	"./hsb.d.ts": 51010,
	"./hsb.js": 39321,
	"./hu": 35549,
	"./hu.d": 78316,
	"./hu.d.ts": 78316,
	"./hu.js": 35549,
	"./hy": 72633,
	"./hy.d": 80408,
	"./hy.d.ts": 80408,
	"./hy.js": 72633,
	"./ia": 62952,
	"./ia.d": 83429,
	"./ia.d.ts": 83429,
	"./ia.js": 62952,
	"./id": 2043,
	"./id.d": 94950,
	"./id.d.ts": 94950,
	"./id.js": 2043,
	"./ig": 98558,
	"./ig.d": 20783,
	"./ig.d.ts": 20783,
	"./ig.js": 98558,
	"./ii": 82752,
	"./ii.d": 93981,
	"./ii.d.ts": 93981,
	"./ii.js": 82752,
	"./io": 13942,
	"./io.d": 44679,
	"./io.d.ts": 44679,
	"./io.js": 13942,
	"./is": 44290,
	"./is.d": 88995,
	"./is.d.ts": 88995,
	"./is.js": 44290,
	"./it": 30251,
	"./it.d": 3446,
	"./it.d.ts": 3446,
	"./it.js": 30251,
	"./iu": 65156,
	"./iu.d": 44465,
	"./iu.d.ts": 44465,
	"./iu.js": 65156,
	"./ja": 30567,
	"./ja.d": 15030,
	"./ja.d.ts": 15030,
	"./ja.js": 30567,
	"./jbo": 93629,
	"./jbo.d": 72554,
	"./jbo.d.ts": 72554,
	"./jbo.js": 93629,
	"./jgo": 43316,
	"./jgo.d": 1703,
	"./jgo.d.ts": 1703,
	"./jgo.js": 43316,
	"./jmc": 89806,
	"./jmc.d": 53861,
	"./jmc.d.ts": 53861,
	"./jmc.js": 89806,
	"./jv": 41302,
	"./jv.d": 47475,
	"./jv.d.ts": 47475,
	"./jv.js": 41302,
	"./jw": 59541,
	"./jw.d": 69312,
	"./jw.d.ts": 69312,
	"./jw.js": 59541,
	"./ka": 71702,
	"./ka.d": 43115,
	"./ka.d.ts": 43115,
	"./ka.js": 71702,
	"./kab": 878,
	"./kab.d": 88525,
	"./kab.d.ts": 88525,
	"./kab.js": 878,
	"./kaj": 32070,
	"./kaj.d": 31285,
	"./kaj.d.ts": 31285,
	"./kaj.js": 32070,
	"./kcg": 14839,
	"./kcg.d": 65352,
	"./kcg.d.ts": 65352,
	"./kcg.js": 14839,
	"./kde": 84810,
	"./kde.d": 34677,
	"./kde.d.ts": 34677,
	"./kde.js": 84810,
	"./kea": 27719,
	"./kea.d": 12044,
	"./kea.d.ts": 12044,
	"./kea.js": 27719,
	"./kk": 2804,
	"./kk.d": 34501,
	"./kk.d.ts": 34501,
	"./kk.js": 2804,
	"./kkj": 48412,
	"./kkj.d": 54183,
	"./kkj.d.ts": 54183,
	"./kkj.js": 48412,
	"./kl": 74145,
	"./kl.d": 940,
	"./kl.d.ts": 940,
	"./kl.js": 74145,
	"./km": 20242,
	"./km.d": 20591,
	"./km.d.ts": 20591,
	"./km.js": 20242,
	"./kn": 78623,
	"./kn.d": 11110,
	"./kn.d.ts": 11110,
	"./kn.js": 78623,
	"./ko": 44008,
	"./ko.d": 48705,
	"./ko.d.ts": 48705,
	"./ko.js": 44008,
	"./ks": 72348,
	"./ks.d": 57965,
	"./ks.d.ts": 57965,
	"./ks.js": 72348,
	"./ksb": 44412,
	"./ksb.d": 44743,
	"./ksb.d.ts": 44743,
	"./ksb.js": 44412,
	"./ksh": 75214,
	"./ksh.d": 57121,
	"./ksh.d.ts": 57121,
	"./ksh.js": 75214,
	"./ku": 73594,
	"./ku.d": 44823,
	"./ku.d.ts": 44823,
	"./ku.js": 73594,
	"./kw": 19920,
	"./kw.d": 31113,
	"./kw.d.ts": 31113,
	"./kw.js": 19920,
	"./ky": 44782,
	"./ky.d": 48579,
	"./ky.d.ts": 48579,
	"./ky.js": 44782,
	"./lag": 76412,
	"./lag.d": 57619,
	"./lag.d.ts": 57619,
	"./lag.js": 76412,
	"./lb": 33004,
	"./lb.d": 34505,
	"./lb.d.ts": 34505,
	"./lb.js": 33004,
	"./lg": 80503,
	"./lg.d": 88802,
	"./lg.d.ts": 88802,
	"./lg.js": 80503,
	"./lij": 10231,
	"./lij.d": 75948,
	"./lij.d.ts": 75948,
	"./lij.js": 10231,
	"./lkt": 82127,
	"./lkt.d": 53792,
	"./lkt.d.ts": 53792,
	"./lkt.js": 82127,
	"./ln": 94280,
	"./ln.d": 58261,
	"./ln.d.ts": 58261,
	"./ln.js": 94280,
	"./lo": 86367,
	"./lo.d": 88810,
	"./lo.d.ts": 88810,
	"./lo.js": 86367,
	"./lt": 64986,
	"./lt.d": 48619,
	"./lt.d.ts": 48619,
	"./lt.js": 64986,
	"./lv": 44560,
	"./lv.d": 14429,
	"./lv.d.ts": 14429,
	"./lv.js": 44560,
	"./mas": 71187,
	"./mas.d": 94760,
	"./mas.d.ts": 94760,
	"./mas.js": 71187,
	"./mg": 39674,
	"./mg.d": 14283,
	"./mg.d.ts": 14283,
	"./mg.js": 39674,
	"./mgo": 3293,
	"./mgo.d": 56022,
	"./mgo.d.ts": 56022,
	"./mgo.js": 3293,
	"./mk": 27214,
	"./mk.d": 92495,
	"./mk.d.ts": 92495,
	"./mk.js": 27214,
	"./ml": 7599,
	"./ml.d": 7066,
	"./ml.d.ts": 7066,
	"./ml.js": 7599,
	"./mn": 35473,
	"./mn.d": 6144,
	"./mn.d.ts": 6144,
	"./mn.js": 35473,
	"./mo": 33410,
	"./mo.d": 10163,
	"./mo.d.ts": 10163,
	"./mo.js": 33410,
	"./mr": 72373,
	"./mr.d": 80756,
	"./mr.d.ts": 80756,
	"./mr.js": 72373,
	"./ms": 54134,
	"./ms.d": 68023,
	"./ms.d.ts": 68023,
	"./ms.js": 54134,
	"./mt": 70647,
	"./mt.d": 54466,
	"./mt.d.ts": 54466,
	"./mt.js": 70647,
	"./my": 85236,
	"./my.d": 30577,
	"./my.d.ts": 30577,
	"./my.js": 85236,
	"./nah": 1955,
	"./nah.d": 61680,
	"./nah.d.ts": 61680,
	"./nah.js": 1955,
	"./naq": 27476,
	"./naq.d": 31531,
	"./naq.d.ts": 31531,
	"./naq.js": 27476,
	"./nb": 52814,
	"./nb.d": 79539,
	"./nb.d.ts": 79539,
	"./nb.js": 52814,
	"./nd": 86392,
	"./nd.d": 58177,
	"./nd.d.ts": 58177,
	"./nd.js": 86392,
	"./ne": 13967,
	"./ne.d": 20582,
	"./ne.d.ts": 20582,
	"./ne.js": 13967,
	"./nl": 85424,
	"./nl.d": 19801,
	"./nl.d.ts": 19801,
	"./nl.js": 85424,
	"./nn": 81626,
	"./nn.d": 45799,
	"./nn.d.ts": 45799,
	"./nn.js": 81626,
	"./nnh": 10856,
	"./nnh.d": 99847,
	"./nnh.d.ts": 99847,
	"./nnh.js": 10856,
	"./no": 35785,
	"./no.d": 10564,
	"./no.d.ts": 10564,
	"./no.js": 35785,
	"./nqo": 63882,
	"./nqo.d": 17089,
	"./nqo.d.ts": 17089,
	"./nqo.js": 63882,
	"./nr": 79806,
	"./nr.d": 7523,
	"./nr.d.ts": 7523,
	"./nr.js": 79806,
	"./nso": 33580,
	"./nso.d": 96711,
	"./nso.d.ts": 96711,
	"./nso.js": 33580,
	"./ny": 96499,
	"./ny.d": 86370,
	"./ny.d.ts": 86370,
	"./ny.js": 96499,
	"./nyn": 2929,
	"./nyn.d": 6622,
	"./nyn.d.ts": 6622,
	"./nyn.js": 2929,
	"./om": 64142,
	"./om.d": 27131,
	"./om.d.ts": 27131,
	"./om.js": 64142,
	"./or": 50103,
	"./or.d": 67398,
	"./or.d.ts": 67398,
	"./or.js": 50103,
	"./os": 44032,
	"./os.d": 78145,
	"./os.d.ts": 78145,
	"./os.js": 44032,
	"./osa": 63537,
	"./osa.d": 65578,
	"./osa.d.ts": 65578,
	"./osa.js": 63537,
	"./pa": 87609,
	"./pa.d": 43656,
	"./pa.d.ts": 43656,
	"./pa.js": 87609,
	"./pap": 89573,
	"./pap.d": 87058,
	"./pap.d.ts": 87058,
	"./pap.js": 89573,
	"./pcm": 92172,
	"./pcm.d": 48935,
	"./pcm.d.ts": 48935,
	"./pcm.js": 92172,
	"./pl": 78174,
	"./pl.d": 81919,
	"./pl.d.ts": 81919,
	"./pl.js": 78174,
	"./prg": 91963,
	"./prg.d": 21512,
	"./prg.d.ts": 21512,
	"./prg.js": 91963,
	"./ps": 64487,
	"./ps.d": 82578,
	"./ps.d.ts": 82578,
	"./ps.js": 64487,
	"./pt": 93222,
	"./pt-PT": 40755,
	"./pt-PT.d": 73020,
	"./pt-PT.d.ts": 73020,
	"./pt-PT.js": 40755,
	"./pt.d": 90503,
	"./pt.d.ts": 90503,
	"./pt.js": 93222,
	"./rm": 36067,
	"./rm.d": 29450,
	"./rm.d.ts": 29450,
	"./rm.js": 36067,
	"./ro": 84165,
	"./ro.d": 47760,
	"./ro.d.ts": 47760,
	"./ro.js": 84165,
	"./rof": 96595,
	"./rof.d": 15212,
	"./rof.d.ts": 15212,
	"./rof.js": 96595,
	"./ru": 84411,
	"./ru.d": 97010,
	"./ru.d.ts": 97010,
	"./ru.js": 84411,
	"./rwk": 1184,
	"./rwk.d": 13715,
	"./rwk.d.ts": 13715,
	"./rwk.js": 1184,
	"./sah": 89252,
	"./sah.d": 39739,
	"./sah.d.ts": 39739,
	"./sah.js": 89252,
	"./saq": 91859,
	"./saq.d": 256,
	"./saq.d.ts": 256,
	"./saq.js": 91859,
	"./sat": 6848,
	"./sat.d": 2223,
	"./sat.d.ts": 2223,
	"./sat.js": 6848,
	"./sc": 66868,
	"./sc.d": 70453,
	"./sc.d.ts": 70453,
	"./sc.js": 66868,
	"./scn": 56272,
	"./scn.d": 34203,
	"./scn.d.ts": 34203,
	"./scn.js": 56272,
	"./sd": 68289,
	"./sd.d": 19484,
	"./sd.d.ts": 19484,
	"./sd.js": 68289,
	"./sdh": 51493,
	"./sdh.d": 17190,
	"./sdh.d.ts": 17190,
	"./sdh.js": 51493,
	"./se": 84306,
	"./se.d": 14687,
	"./se.d.ts": 14687,
	"./se.js": 84306,
	"./seh": 43360,
	"./seh.d": 19743,
	"./seh.d.ts": 19743,
	"./seh.js": 43360,
	"./ses": 72785,
	"./ses.d": 19326,
	"./ses.d.ts": 19326,
	"./ses.js": 72785,
	"./sg": 99016,
	"./sg.d": 65585,
	"./sg.d.ts": 65585,
	"./sg.js": 99016,
	"./sh": 35669,
	"./sh.d": 53128,
	"./sh.d.ts": 53128,
	"./sh.js": 35669,
	"./shi": 55554,
	"./shi.d": 43669,
	"./shi.d.ts": 43669,
	"./shi.js": 55554,
	"./si": 26710,
	"./si.d": 75803,
	"./si.d.ts": 75803,
	"./si.js": 26710,
	"./sk": 54092,
	"./sk.d": 27693,
	"./sk.d.ts": 27693,
	"./sk.js": 54092,
	"./sl": 12921,
	"./sl.d": 27284,
	"./sl.d.ts": 27284,
	"./sl.js": 12921,
	"./sma": 37479,
	"./sma.d": 56220,
	"./sma.d.ts": 56220,
	"./sma.js": 37479,
	"./smi": 59151,
	"./smi.d": 47668,
	"./smi.d.ts": 47668,
	"./smi.js": 59151,
	"./smj": 61666,
	"./smj.d": 43785,
	"./smj.d.ts": 43785,
	"./smj.js": 61666,
	"./smn": 97998,
	"./smn.d": 64429,
	"./smn.d.ts": 64429,
	"./smn.js": 97998,
	"./sms": 34425,
	"./sms.d": 52806,
	"./sms.d.ts": 52806,
	"./sms.js": 34425,
	"./sn": 1591,
	"./sn.d": 29262,
	"./sn.d.ts": 29262,
	"./sn.js": 1591,
	"./so": 11872,
	"./so.d": 23401,
	"./so.d.ts": 23401,
	"./so.js": 11872,
	"./sq": 15630,
	"./sq.d": 82867,
	"./sq.d.ts": 82867,
	"./sq.js": 15630,
	"./sr": 16843,
	"./sr.d": 22842,
	"./sr.d.ts": 22842,
	"./sr.js": 16843,
	"./ss": 1220,
	"./ss.d": 4549,
	"./ss.d.ts": 4549,
	"./ss.js": 1220,
	"./ssy": 12357,
	"./ssy.d": 50190,
	"./ssy.d.ts": 50190,
	"./ssy.js": 12357,
	"./st": 24945,
	"./st.d": 65100,
	"./st.d.ts": 65100,
	"./st.js": 24945,
	"./su": 57058,
	"./su.d": 41903,
	"./su.d.ts": 41903,
	"./su.js": 57058,
	"./sv": 19311,
	"./sv.d": 16070,
	"./sv.d.ts": 16070,
	"./sv.js": 19311,
	"./sw": 84952,
	"./sw.d": 26817,
	"./sw.d.ts": 26817,
	"./sw.js": 84952,
	"./syr": 49486,
	"./syr.d": 47389,
	"./syr.d.ts": 47389,
	"./syr.js": 49486,
	"./ta": 23645,
	"./ta.d": 30764,
	"./ta.d.ts": 30764,
	"./ta.js": 23645,
	"./te": 39393,
	"./te.d": 1984,
	"./te.d.ts": 1984,
	"./te.js": 39393,
	"./teo": 65680,
	"./teo.d": 55639,
	"./teo.d.ts": 55639,
	"./teo.js": 65680,
	"./th": 36950,
	"./th.d": 31463,
	"./th.d.ts": 31463,
	"./th.js": 36950,
	"./ti": 12661,
	"./ti.d": 38980,
	"./ti.d.ts": 38980,
	"./ti.js": 12661,
	"./tig": 5852,
	"./tig.d": 60835,
	"./tig.d.ts": 60835,
	"./tig.js": 5852,
	"./tk": 14067,
	"./tk.d": 6110,
	"./tk.d.ts": 6110,
	"./tk.js": 14067,
	"./tl": 52906,
	"./tl.d": 52651,
	"./tl.d.ts": 52651,
	"./tl.js": 52906,
	"./tn": 88864,
	"./tn.d": 97117,
	"./tn.d.ts": 97117,
	"./tn.js": 88864,
	"./to": 30167,
	"./to.d": 23538,
	"./to.d.ts": 23538,
	"./to.js": 30167,
	"./tpi": 92475,
	"./tpi.d": 13564,
	"./tpi.d.ts": 13564,
	"./tpi.js": 92475,
	"./tr": 71812,
	"./tr.d": 31249,
	"./tr.d.ts": 31249,
	"./tr.js": 71812,
	"./ts": 93835,
	"./ts.d": 90230,
	"./ts.d.ts": 90230,
	"./ts.js": 93835,
	"./tzm": 61969,
	"./tzm.d": 39510,
	"./tzm.d.ts": 39510,
	"./tzm.js": 61969,
	"./ug": 39490,
	"./ug.d": 69699,
	"./ug.d.ts": 69699,
	"./ug.js": 39490,
	"./uk": 78726,
	"./uk.d": 82295,
	"./uk.d.ts": 82295,
	"./uk.js": 78726,
	"./und": 65481,
	"./und.d": 29774,
	"./und.d.ts": 29774,
	"./und.js": 65481,
	"./ur": 77501,
	"./ur.d": 38412,
	"./ur.d.ts": 38412,
	"./ur.js": 77501,
	"./uz": 18101,
	"./uz.d": 7812,
	"./uz.d.ts": 7812,
	"./uz.js": 18101,
	"./ve": 59639,
	"./ve.d": 11646,
	"./ve.d.ts": 11646,
	"./ve.js": 59639,
	"./vi": 89211,
	"./vi.d": 59130,
	"./vi.d.ts": 59130,
	"./vi.js": 89211,
	"./vo": 68865,
	"./vo.d": 4076,
	"./vo.d.ts": 4076,
	"./vo.js": 68865,
	"./vun": 91109,
	"./vun.d": 49242,
	"./vun.d.ts": 49242,
	"./vun.js": 91109,
	"./wa": 3650,
	"./wa.d": 5495,
	"./wa.d.ts": 5495,
	"./wa.js": 3650,
	"./wae": 96587,
	"./wae.d": 13360,
	"./wae.d.ts": 13360,
	"./wae.js": 96587,
	"./wo": 48316,
	"./wo.d": 45045,
	"./wo.d.ts": 45045,
	"./wo.js": 48316,
	"./xh": 87306,
	"./xh.d": 53675,
	"./xh.d.ts": 53675,
	"./xh.js": 87306,
	"./xog": 13626,
	"./xog.d": 61549,
	"./xog.d.ts": 61549,
	"./xog.js": 13626,
	"./yi": 94256,
	"./yi.d": 49357,
	"./yi.d.ts": 49357,
	"./yi.js": 94256,
	"./yo": 80390,
	"./yo.d": 29271,
	"./yo.d.ts": 29271,
	"./yo.js": 80390,
	"./yue": 69201,
	"./yue.d": 96374,
	"./yue.d.ts": 96374,
	"./yue.js": 69201,
	"./zh": 83592,
	"./zh.d": 83225,
	"./zh.d.ts": 83225,
	"./zh.js": 83592,
	"./zu": 51043,
	"./zu.d": 65034,
	"./zu.d.ts": 65034,
	"./zu.js": 51043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83327;